import ApiClient from '@/libs/http-client'

const ProjectsService = {
    endpoints(route, param ) {
        const url = {
            personalTasks: '/api/tasks/my',
            taskStatuses: '/api/tasks/statuses',
            changeTaskStatus: `api/tasks/${param}`,
            getCurrentTask: `api/tasks/${param}`,
            getCurrentTaskByTag: `api/tasks/tag/${param}`,

            getCurrentTaskInfo: `api/projects/slug/${param}/info`,
            projectStatuses: `/api/projects/${param}/statuses`,
            projectStatusesFull: `/api/projects/${param}/statuses?full=1`,
            statusPositions: `api/projects/${param}/statuses/positions`,
            projectStatusToggle: `api/projects/${param.id}/statuses/${param.statusId}`,
            userProjects: `/api/users/${param}/projects`,
            userTasks: `/api/users/${param}/tasks`,
            todos: `/api/tasks/${param}/todos`,
            comments: `/api/tasks/${param}/comments`,
            createTask: '/api/tasks/',
            deleteTask: `/api/tasks/${param}`,
            editTask: `/api/tasks/${param}`,
            editProject: `/api/projects/${param}`,
            activeProjects: '/api/projects?active=1',
            projects: '/api/projects',
            allClients: '/api/clients',
            kanbanBoards: '/api/tasks/statuses',
            clients: `/api/users?role_id=2&author_id=${param}`,
            projectTasks: `/api/tasks?project_id=${param}`,

            projectTasksParent: `/api/tasks?project_id=${param.id}&status_ids=${param.statusIds}`,

            projectSlug: `/api/projects/slug/${param}`,
            taskSlug: `/api/projects/${param.project}/tasks/tag/${param.task}`,

            getReleases: `/api/projects/${param}/releases`,
            getTasksForRelease: `/api/tasks?project_id=${param}&can_be_added_to_release=1`,
            getCurrentRelease: `/api/projects/${param.project}/releases/${param.id}`,
            getReleaseOptions: `/api/projects/${param}/releases?status=in_progress`,
            pinnedTasks: '/api/pinned-tasks'
            // deleteRelease: `/api/projects/${param.projectIdId}/releases/${param.releaseId}`,
        };

        return url[route];
    },
    get(url, params = {}) {
        return ApiClient.get(this.endpoints(url, params));
    },
    put(url, params = {}, data, config = {}) {
        return ApiClient.put(this.endpoints(url, params), data, config);
    },
    post(url, params = {}, data, config = {}) {
        return ApiClient.post(this.endpoints(url, params), data, config);
    },
    patch(url, params = {}, data, config = {}) {
        return ApiClient.patch(this.endpoints(url, params), data, config);
    },
    delete(url, params = {}, config = {}) {
        return ApiClient.delete(this.endpoints(url, params), config);
    },
    getTaskComments(id, config = {}) {
        return ApiClient.get(`/api/tasks/${id}/comments`, config);
    },
    createNewTaskComment(id, data, config = {}) {
        return ApiClient.post(`/api/tasks/${id}/comments`, data, config);
    },
    editNewTaskComment(taskId, commentId, data, config = {}) {
        const isFormData = typeof FormData !== 'undefined' && data instanceof FormData
        if (isFormData) {
            if (!data.has('_method')) {
                data.append('_method', 'PUT')
            }
            return ApiClient.post(`/api/tasks/${taskId}/comments/${commentId}`, data, config)
        }
        return ApiClient.put(`/api/tasks/${taskId}/comments/${commentId}`, data, config);
    },
    editTodo(taskId, commentId, data, config = {}) {
        return ApiClient.put(`/api/tasks/${taskId}/todos/${commentId}`, data, config);
    },
    release(projectId, releaseId, data, config = {}) {
        return ApiClient.put(`/api/projects/${projectId}/releases/${releaseId}`, data, config);
    },
    addProjectInfo(slug, data, config = {}) {
        return ApiClient.put(`/api/projects/slug/${slug}/info`, data, config);
    },
    deleteNewTaskComment(taskId, commentId, config = {}) {
        return ApiClient.delete(`/api/tasks/${taskId}/comments/${commentId}`, config);
    },
    deleteRelease(projectId, releaseId, config = {}) {
        return ApiClient.delete(`/api/projects/${projectId}/releases/${releaseId}`, config);
    },
    clearBoard(project, board, config = {}) {
        return ApiClient.delete(`/api/tasks?project_id=${project}&status_id=${board}`, config);
    },
    deleteTodo(taskId, commentId, config = {}) {
        return ApiClient.delete(`/api/tasks/${taskId}/todos/${commentId}`, config);
    },
    getTaskStatuses(config) {
        return ApiClient.get('/api/tasks/statuses', config)
    },
    getProjectStatuses(projectId, full = true, config = {}) {
        const url = full ? this.endpoints('projectStatusesFull', projectId) : this.endpoints('projectStatuses', projectId)
        return ApiClient.get(url, config)
    },
    addProjectStatus(projectId, data, config = {}) {
        return ApiClient.post(`/api/projects/${projectId}/statuses`, data, config)
    },
    deleteProjectStatus(projectId, data, config = {}) {
        return ApiClient.delete(`/api/projects/${projectId}/statuses`, { ...config, data })
    },
    updateTaskStatus(statusId, data, config = {}) {
        return ApiClient.put(`/api/tasks/statuses/${statusId}`, data, config)
    },
    toggleProjectStatus(projectId, statusId, config = {}) {
        return ApiClient.put(this.endpoints('projectStatusToggle', { id: projectId, statusId }), null, config)
    },
    updateStatusPositions(projectId, positions, config = {}) {
        return ApiClient.put(this.endpoints('statusPositions', projectId), positions, config)
    },
    patchProjectStatusPosition(projectId, data, config = {}) {
        return ApiClient.patch(this.endpoints('projectStatuses', projectId), data, config)
    },
    deleteTaskStatus(statusId, config = {}) {
        return ApiClient.delete(`/api/tasks/statuses/${statusId}`, config)
    },
    addNewComment(id, data, config = {}) {
        return this.createNewTaskComment(id, data, config)
    },
    createRelease(id, data, config) {
        return ApiClient.post(`/api/projects/${id}/releases`, data, config)
    },
    addTodo(id, data, config) {
        return ApiClient.post(`/api/tasks/${id}/todos`, data, config)
    },
    getTaskAttachments(taskId, config = {}) {
        return ApiClient.get(`/api/tasks/${taskId}/attachments`, config)
    },
    uploadTaskAttachment(taskId, data, config = {}) {
        return ApiClient.post(`/api/tasks/${taskId}/attachments`, data, config)
    },
    deleteTaskAttachment(taskId, attachmentId, config = {}) {
        return ApiClient.delete(`/api/tasks/${taskId}/attachments/${attachmentId}`, config)
    },
    createNewTask(data, config) {
        return ApiClient.post('/api/tasks', data, config)
    },

    createNewProject(data, config) {
        return ApiClient.post('/api/projects', data, config)
    },

    searchTasks(projectId, query, config = {}) {
        return ApiClient.get(`/api/tasks/${projectId}/search`, { ...config, params: { query } });
    },

    getPinnedTasks(config = {}) {
        return ApiClient.get('/api/pinned-tasks', config)
    },

    togglePinnedTask(projectId, taskId, config = {}) {
        return ApiClient.post('/api/pinned-tasks', { project_id: projectId, task_id: taskId }, config)
    },

    getProjectTasksByStatusIds(projectId, statusIds, config = {}) {
        const ids = Array.isArray(statusIds) ? statusIds : (statusIds != null ? [statusIds] : [])
        const cleaned = ids.map((x) => Number(x)).filter((n) => !Number.isNaN(n))
        const params = { ...(config.params || {}), project_id: projectId, status_ids: cleaned.join(',') }
        return ApiClient.get('/api/tasks', { ...config, params })
    },

}

export default ProjectsService
